import { RootState } from 'store';

export const balanceData = (state: RootState) => state.balanceData;
